import { endpoint } from 'services/Api';

/**
 * Contacts Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'contacts';

/**
 * Contacts Resource Endpoints:
 *     - search
 */
export default {
    /**
     * Search Endpoints.
     *
     * @type {}
     */
    search: data => endpoint(`${RESOURCE}`, 'search', data).then(data => {
        return {
            data
        }
    }),
};



// WEBPACK FOOTER //
// ./src/services/api/contacts.js